import { sortObjectArrays } from '../sortObjectArrays';
import { stableHash } from './stableHash';

export function sortedHash<TObject extends Record<string, unknown>>(
  object: TObject,
) {
  return stableHash(sortObjectArrays(object));
}
